var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"coverage-item-container",attrs:{"cols":"6","sm":"6","md":"12","lg":"6"}},[_c('b-icon',{staticClass:"h5 icon",attrs:{"icon":"check-circle-fill"}}),_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }